import { Fieldset, Paragraph, Radio, Textfield, ValidationMessage } from '@digdir/designsystemet-react';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { useSolcelleFormContext } from '../utils';

import { useSolcellerValidation } from './useSolcellerValidation';

export const ProductionData = () => {
  const { t } = useTranslation();
  const { register, watch, formState } = useSolcelleFormContext();
  const { validateKwh } = useSolcellerValidation();
  const { decimalPattern } = useSolcellerValidation();

  const productionDataSelection = watch('productionData');

  // Renders radio with corresponding input based on selection
  return (
    <Fragment>
      <Fieldset>
        <Fieldset.Legend>{t('register.solar.form.productionData.label')}</Fieldset.Legend>
        <Radio
          {...register('productionData', { required: t('register.solar.form.productionData.error') })}
          label={t('register.solar.form.productionData.option.average')}
          value="actualProduction"
        />
        <Radio
          {...register('productionData', { required: t('register.solar.form.productionData.error') })}
          label={t('register.solar.form.productionData.option.calculated')}
          value="calculatedProduction"
        />
        <Radio
          {...register('productionData', { required: t('register.solar.form.productionData.error') })}
          label={t('register.solar.form.productionData.option.unknown')}
          value="unknown"
        />
        {formState.errors.productionData && (
          <ValidationMessage data-color="danger">{formState.errors.productionData.message}</ValidationMessage>
        )}
      </Fieldset>

      {productionDataSelection === 'actualProduction' && (
        <Textfield
          type="text"
          inputMode="decimal"
          {...register('producedKwh', {
            required: t('register.solar.form.productionData.faktiskProdusert.error'),
            validate: validateKwh,
            pattern: decimalPattern
          })}
          error={formState.errors.producedKwh?.message}
          label={t('register.solar.form.productionData.faktiskProdusert.label')}
          suffix={t('register.solar.form.suffix.kwhYear')}
        />
      )}
      {productionDataSelection === 'calculatedProduction' && (
        <Textfield
          type="text"
          inputMode="decimal"
          {...register('calculatedKwh', {
            required: t('register.solar.form.productionData.beregnetProduksjon.error'),
            validate: validateKwh,
            pattern: decimalPattern
          })}
          error={formState.errors.calculatedKwh?.message}
          label={t('register.solar.form.productionData.beregnetProduksjon.label')}
          suffix={t('register.solar.form.suffix.kwhYear')}
        />
      )}
      {productionDataSelection === 'unknown' && (
        <Paragraph>{t('register.solar.form.productionData.unknown.label')}</Paragraph>
      )}
    </Fragment>
  );
};
